import { useState, useEffect, useCallback } from "react";
import { adminService } from "@b2b/services";
import { useAuth } from "../auth/Authprovider";
import { UserStatistics } from "../types/user.types";

export function useUserStats() {
  const {
    isLoading: authLoading,
    isAuthenticated,
  } = useAuth();
  
  const [stats, setStats] = useState<UserStatistics>({
    total: 0,
    active: 0,
    inactive: 0,
    pending: 0,
    recentRegistrations: 0,
    byRole: {},
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStats = useCallback(async (forceRefresh = false) => {
    try {
      setLoading(true);
      setError(null);
      const statsData = await adminService.getUserStatistics();
      setStats(statsData);
    } catch (err) {
      console.error("Error fetching user stats:", err);
      setError(err instanceof Error ? err.message : "Failed to fetch statistics");
    } finally {
      setLoading(false);
    }
  }, []);

  const refresh = useCallback(async () => {
    await fetchStats(true);
  }, [fetchStats]);

  // Initial load
  useEffect(() => {
    if (authLoading || !isAuthenticated) return;

    let isMounted = true;

    const initialLoad = async () => {
      const { getAccessToken } = await import("@b2b/services");
      const token = await getAccessToken();
      if (!token) {
        if (isMounted) {
          setTimeout(() => initialLoad(), 500);
        }
        return;
      }

      if (!isMounted) return;
      await fetchStats(true);
    };

    initialLoad();

    return () => {
      isMounted = false;
    };
  }, [authLoading, isAuthenticated, fetchStats]);

  return {
    stats,
    loading,
    error,
    refresh,
  };
}

